import { render, staticRenderFns } from "./ChatHistoryViewAll.vue?vue&type=template&id=d1f32aee&scoped=true"
import script from "./ChatHistoryViewAll.vue?vue&type=script&lang=js"
export * from "./ChatHistoryViewAll.vue?vue&type=script&lang=js"
import style0 from "./ChatHistoryViewAll.vue?vue&type=style&index=0&id=d1f32aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f32aee",
  null
  
)

export default component.exports